import { render, staticRenderFns } from "./transferClassByCourse.vue?vue&type=template&id=49adc3b1&"
import script from "./transferClassByCourse.vue?vue&type=script&lang=js&"
export * from "./transferClassByCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports